export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Administracja": "",
        "Aktywny": "",
        "Anuluj": "",
        "Brak pasujących dokumentów": "",
        "Brak pasujących stron": "",
        "Data dodania": "",
        "Data indeksowania": "",
        "Data modyfikacji": "",
        "Dodaj słowo": "",
        "Dodaj synonim": "",
        "Dodaj synonimy": "",
        "Dokument": "",
        "Dokumenty": "",
        "Edytuj": "",
        "Embeddings": "",
        "Endpoint listy indeksów nie jest dostępny. Wdróż aktualną wersję API.": "",
        "Health": "",
        "ID": "",
        "ID dokumentu": "",
        "ID encji": "",
        "Indeks": "",
        "Lista indeksów": "",
        "Mappingi": "",
        "Nie dotyczy": "",
        "Nie znaleziono dokumentu.": "",
        "Otwarty": "",
        "Partycja": "",
        "Podaj ID dokumentu i kliknij „Szukaj”, aby pobrać jego zawartość.": "",
        "Podgląd indeksu": "",
        "Potwierdzenie usunięcia": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksów\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.\n\nNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danych\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.\n\nNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "Rozmiar": "",
        "Słowa wykluczone": "",
        "Słowo": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Spróbuj wpisać inną nazwę strony.": "",
        "Status": "",
        "Statusy": "",
        "Strony": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "Szczegóły": "",
        "Szczegóły dokumentu": "",
        "Szkic": "",
        "Szukaj": "",
        "Szukane słowo": "",
        "Typ encji": "",
        "Tytuł": "",
        "Ustawienia": "",
        "Usuń": "",
        "Usunięty": "",
        "Wpisz jedno słowo, które wyszukiwarka ma pomijać, np. „i” lub „oraz”. Każde słowo dodaj jako osobny wpis.": "",
        "Wpisz każdy synonim w osobnym polu. Kliknij „Dodaj synonim”, aby dodać kolejne określenie.": "",
        "Wpisz słowo główne, do którego chcesz przypisać alternatywne określenia używane przy wyszukiwaniu.": "",
        "Wyszukiwanie": "",
        "Zaakceptowany": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zakończony": "",
        "Zamknij": "",
        "Zapisz": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "",
        "Zmień filtry lub wpisz inną frazę.": ""
    }
};
